var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pms-performance-report-progress-bar"},[_c('div',{staticClass:"label-container"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('span',{staticClass:"percent"},[_vm._v(_vm._s(_vm.value)+"%")])]),_c('v-progress-linear',{attrs:{"background-color":"#c4c4c4","color":"#8de38b","value":_vm.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }